import u45m from '@/assets/UniLogo/u45m.png'
import utsntb from '@/assets/UniLogo/utsntb.png'
import stikes from '@/assets/UniLogo/stikesntb.jpeg'
import nuuntb from '@/assets/UniLogo/ununtb.jpeg'
import LuxTagTest from '@/assets/UniLogo/LuxTagTest.png'

export {
    u45m,
    utsntb,
    stikes,
    nuuntb,
    LuxTagTest
};;


// WEBPACK FOOTER //
// ./src/assets/js/logoMapping.js